/* Mobiel hamburgermenu Tavellio: het inschuiven van de panelen.

   Het openen en sluiten van de lade zelf doet het thema. Dit script regelt
   alleen welk paneel zichtbaar is.

   Het script staat in een sectie die later kan laden dan de header, dus het
   wacht op DOMContentLoaded en zoekt het menu bij elke klik opnieuw op in
   plaats van de elementen één keer te onthouden.
   Zie [[reference_thema_script_volgorde]].
*/
(function () {
  'use strict';

  var KLAAR = 'tavm--gereed';

  // Voert fn uit op het eerstvolgende tekenmoment, of na 30 ms als het
  // tabblad niet tekent (verborgen venster, achtergrondtab).
  function schuif(fn) {
    var gedaan = false;
    function eenmaal() {
      if (gedaan) return;
      gedaan = true;
      fn();
    }
    if (window.requestAnimationFrame) requestAnimationFrame(eenmaal);
    window.setTimeout(eenmaal, 30);
  }

  // De taal- en valutakiezer is een eigen blok onder het menu en hoort alleen
  // op de eerste pagina thuis. Een klasse op de omhullende sectie laat de CSS
  // weten dat we een niveau dieper zitten.
  function diepte(menu, diep) {
    var houder = menu.closest('mobile-menu') || menu.closest('[data-drawer]');
    if (houder) houder.classList.toggle('tavm-diep', !!diep);
  }

  function paneelVan(menu, naam) {
    return menu.querySelector('[data-tavm-paneel="' + naam + '"]');
  }

  function hoofdVan(menu) {
    return menu.querySelector('[data-tavm-niveau="0"]');
  }

  function sluitAlles(menu) {
    var hoofd = hoofdVan(menu);
    menu.querySelectorAll('[data-tavm-niveau="1"]').forEach(function (p) {
      p.classList.remove('tavm__paneel--actief');
      p.hidden = true;
    });
    menu.querySelectorAll('[data-tavm-open]').forEach(function (k) {
      k.setAttribute('aria-expanded', 'false');
    });
    if (hoofd) {
      hoofd.classList.remove('tavm__paneel--weg', 'tavm__paneel--klaar');
      hoofd.classList.add('tavm__paneel--actief');
      hoofd.hidden = false;
      diepte(menu, false);
    }
  }

  function open(menu, naam, knop) {
    var paneel = paneelVan(menu, naam);
    var hoofd = hoofdVan(menu);
    if (!paneel || !hoofd) return;

    // Eerst zichtbaar maken, dan pas laten schuiven: een element dat van
    // hidden af komt animeert niet als je beide in dezelfde tel doet.
    paneel.hidden = false;
    // requestAnimationFrame vuurt niet in een tabblad dat niet tekent, en dan
    // zou het paneel nooit opengaan. Daarom een wekker als achtervang.
    schuif(function () {
      hoofd.classList.add('tavm__paneel--weg');
      hoofd.classList.remove('tavm__paneel--actief');
      hoofd.classList.remove('tavm__paneel--klaar');
      window.setTimeout(function () {
        if (hoofd.classList.contains('tavm__paneel--weg')) {
          hoofd.classList.add('tavm__paneel--klaar');
        }
      }, 360);
      paneel.classList.add('tavm__paneel--actief');
      paneel.scrollTop = 0;
    });

    if (knop) knop.setAttribute('aria-expanded', 'true');
    diepte(menu, true);

    var terug = paneel.querySelector('[data-tavm-terug]');
    if (terug) terug.focus({ preventScroll: true });
  }

  function terug(menu) {
    var actief = menu.querySelector('[data-tavm-niveau="1"].tavm__paneel--actief');
    var hoofd = hoofdVan(menu);
    if (!hoofd) return;

    hoofd.classList.remove('tavm__paneel--weg', 'tavm__paneel--klaar');
    hoofd.classList.add('tavm__paneel--actief');
    diepte(menu, false);

    if (actief) {
      actief.classList.remove('tavm__paneel--actief');
      var naam = actief.getAttribute('data-tavm-paneel');
      var knop = menu.querySelector('[data-tavm-open="' + naam + '"]');
      if (knop) {
        knop.setAttribute('aria-expanded', 'false');
        knop.focus({ preventScroll: true });
      }
      // Pas verbergen als het uitschuiven klaar is, anders springt het.
      window.setTimeout(function () {
        if (!actief.classList.contains('tavm__paneel--actief')) actief.hidden = true;
      }, 360);
    }
  }

  function koppel(menu) {
    if (menu.classList.contains(KLAAR)) return;
    menu.classList.add(KLAAR);

    menu.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-tavm-open]');
      if (knop && menu.contains(knop)) {
        e.preventDefault();
        open(menu, knop.getAttribute('data-tavm-open'), knop);
        return;
      }
      var terugknop = e.target.closest('[data-tavm-terug]');
      if (terugknop && menu.contains(terugknop)) {
        e.preventDefault();
        terug(menu);
      }
    });

    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.querySelector('[data-tavm-niveau="1"].tavm__paneel--actief')) {
        e.stopPropagation();
        terug(menu);
      }
    });

    // Gaat de lade dicht, dan begint hij de volgende keer weer bovenaan.
    var lade = menu.closest('[data-drawer]');
    if (lade && window.MutationObserver) {
      new MutationObserver(function () {
        if (!lade.hasAttribute('open') && !lade.classList.contains('is-open')) {
          sluitAlles(menu);
        }
      }).observe(lade, { attributes: true, attributeFilter: ['open', 'class'] });
    }
  }

  function start() {
    document.querySelectorAll('[data-tavm]').forEach(koppel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // De theme-editor bouwt secties opnieuw op.
  document.addEventListener('shopify:section:load', start);
})();
